"use strict";

angular.module('mainApp').factory('Shop', ['$resource', '$cacheFactory', function ($resource, $cacheFactory) {
  var Shop, cache;
  cache = $cacheFactory('Shop');
  Shop = $resource('/api/shop', {
    id: '@id'
  }, {
    breakpoints: {
      cache: cache,
      url: '/api/shop/breakpoints'
    },
    pay: {
      method: 'PUT',
      url: '/api/shop/pay'
    },
    quote: {
      method: 'POST',
      url: '/api/shop/quote'
    }
  });
  return Shop;
}]);
//# sourceMappingURL=data:application/json;charset=utf8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInJlc291cmNlcy9TaG9wLmNvZmZlZSJdLCJuYW1lcyI6WyJhbmd1bGFyIiwibW9kdWxlIiwiZmFjdG9yeSIsIiRyZXNvdXJjZSIsIiRjYWNoZUZhY3RvcnkiLCJTaG9wIiwiY2FjaGUiLCJpZCIsImJyZWFrcG9pbnRzIiwidXJsIiwicGF5IiwibWV0aG9kIiwicXVvdGUiXSwibWFwcGluZ3MiOiI7O0FBQUFBLE9BQU8sQ0FBQ0MsTUFBUixDQUFnQixTQUFoQixDQUEwQixDQUFDQyxPQUEzQixDQUFtQyxNQUFuQyxFQUEyQyxDQUFFLFdBQUYsRUFBZSxlQUFmLEVBQWdDLFVBQUVDLFNBQUYsRUFBYUMsYUFBYixFQUFBO0VBRTNFLElBQUFDLElBQUEsRUFBQUMsS0FBQTtFQUFFQSxLQUFBLEdBQVFGLGFBQUEsQ0FBYyxNQUFkLENBQUE7RUFFUkMsSUFBQSxHQUFPRixTQUFBLENBQVcsV0FBWCxFQUF3QjtJQUFDSSxFQUFBLEVBQUk7RUFBTCxDQUF4QixFQUNMO0lBQUFDLFdBQUEsRUFDRTtNQUFBRixLQUFBLEVBQU9BLEtBQVA7TUFDQUcsR0FBQSxFQUFLO0lBREwsQ0FERjtJQUdBQyxHQUFBLEVBQ0U7TUFBQUMsTUFBQSxFQUFRLEtBQVI7TUFDQUYsR0FBQSxFQUFLO0lBREwsQ0FKRjtJQU1BRyxLQUFBLEVBQ0U7TUFBQUQsTUFBQSxFQUFRLE1BQVI7TUFDQUYsR0FBQSxFQUFLO0lBREw7RUFQRixDQURLLENBQUE7RUFZUCxPQUFPSixJQUFBO0FBaEJrRSxDQUFoQyxDQUEzQyxDQUFBIiwiZmlsZSI6InJlc291cmNlcy9TaG9wLmpzIiwic291cmNlc0NvbnRlbnQiOlsiYW5ndWxhci5tb2R1bGUoICdtYWluQXBwJykuZmFjdG9yeSAnU2hvcCcsIFsgJyRyZXNvdXJjZScsICckY2FjaGVGYWN0b3J5JywgKCAkcmVzb3VyY2UsICRjYWNoZUZhY3RvcnkgKSAtPlxuXG4gIGNhY2hlID0gJGNhY2hlRmFjdG9yeSgnU2hvcCcpXG5cbiAgU2hvcCA9ICRyZXNvdXJjZSggJy9hcGkvc2hvcCcsIHtpZDogJ0BpZCd9LFxuICAgIGJyZWFrcG9pbnRzOlxuICAgICAgY2FjaGU6IGNhY2hlXG4gICAgICB1cmw6ICcvYXBpL3Nob3AvYnJlYWtwb2ludHMnXG4gICAgcGF5OlxuICAgICAgbWV0aG9kOiAnUFVUJ1xuICAgICAgdXJsOiAnL2FwaS9zaG9wL3BheSdcbiAgICBxdW90ZTpcbiAgICAgIG1ldGhvZDogJ1BPU1QnXG4gICAgICB1cmw6ICcvYXBpL3Nob3AvcXVvdGUnXG4gIClcblxuICByZXR1cm4gU2hvcFxuXVxuIl19
